import { useTranslation } from 'react-i18next';
import { useWindowSize } from '@scramble/hooks';
import { Button } from '@scramble/ui';
import IconBack from '@scramble/design-system/icons/arrow-left.svg';
import s from './index.module.scss';

export const NavButton = ({ className, onBack }) => {
  const { t } = useTranslation();
  const { innerWidth } = useWindowSize();

  const isCompact = innerWidth <= 1200;

  return (
    <div className={className}>
      {isCompact ? (
        <Button
          theme="neutral"
          appearance="tonal"
          size="md"
          iconUrl={IconBack}
          className={s.btn_back}
          onClick={onBack}
        />
      ) : (
        <Button
          theme="neutral"
          appearance="tonal"
          size="md"
          className={s.btn_back}
          onClick={onBack}
        >
          <img src={IconBack} width={20} height={20} alt="back" />
          {t('bank_accounts:common.back')}
        </Button>
      )}
    </div>
  );
};


